import { GradientButton } from "components/rhombus-UI/theme/buttons";
import { StaticImage } from "gatsby-plugin-image";
import { css, cx } from "@linaria/core";
import React from "react";
import { ButtonSecondaryLight } from "components/rui/buttons";
import {
  SectionContainer,
  SectionInner,
} from "components/rhombus-UI/theme/containers";
import { Body, TitleLarge } from "components/rui/typography";
import { TextContainer } from "components/rui/layout";
import { styled } from "@linaria/react";

const BannerContainer = styled(SectionContainer)`
  position: relative;
  background-image: url("./assets/roi-banner-bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  ::after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--primary-bg-90);
  }
`;

const BannerContent = styled(TextContainer)`
  z-index: 2;
  max-width: 700px;
`;

const BLURB =
  "Built to protect your bottom line and designed to adapt to your operational needs. The Rhombus cloud-managed platform helps security teams gain operational efficiency that improves ROI, while protecting what matters most.";

const ROIBanner = () => {
  return (
    <BannerContainer>
      <SectionInner>
        <BannerContent>
          <TitleLarge light>Drive ROI and Peace of Mind</TitleLarge>
          <Body light>{BLURB}</Body>
          <ButtonSecondaryLight
            href="/files/generating-positive-roi-with-rhombus.pdf"
            download
          >
            Download ROI Proof
          </ButtonSecondaryLight>
        </BannerContent>
      </SectionInner>
    </BannerContainer>
  );
};

export default ROIBanner;
